'use client';

import { useEffect } from 'react';

const STALE_DEPLOY_PATTERN =
  /Failed to find Server Action|ChunkLoadError|Loading (CSS )?chunk \d+ failed|Loading chunk [\w-]+ failed/i;

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (STALE_DEPLOY_PATTERN.test(error.message || '')) {
      const w = window as unknown as { __aziaRecover?: (reason: string) => void };
      if (typeof w.__aziaRecover === 'function') {
        w.__aziaRecover('global-error-boundary:' + (error.message || '').slice(0, 80));
        return;
      }
      try {
        const u = new URL(location.href);
        u.searchParams.set('_cb', String(Date.now()));
        location.replace(u.toString());
      } catch {
        location.reload();
      }
    }
  }, [error]);

  return (
    <html lang="ru">
      <body>
        <div style={{ textAlign: 'center', padding: '4rem' }}>
          <h2>Что-то пошло не так</h2>
          <button onClick={() => reset()}>Попробовать снова</button>
        </div>
      </body>
    </html>
  );
}
